module.exports = __webpack_public_path__ + "static/media/36.b9592647.png";